// The banner every screen shows while an admin is viewing Cerbie as another user (ADR
// 0009), rendered by the root route. Its Stop button is a plain form posting to
// /impersonation/stop, so it works with JavaScript unavailable, and the page that answers
// is a full reload as the admin.
import { Eye } from "lucide-react";
import { Button } from "~/components/ui/button";

export interface ImpersonationBannerProps {
  /** The user being viewed as: the session's user. */
  username: string;
  /** The admin viewing as them. */
  admin: string;
}

export function ImpersonationBanner({ username, admin }: ImpersonationBannerProps) {
  return (
    <div
      role="status"
      className="sticky top-0 z-[90] flex flex-wrap items-center gap-x-3 gap-y-1 bg-amber-500 px-4 py-1.5 text-sm font-medium text-black"
    >
      <Eye className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>
        You are viewing Cerbie as <strong>{username}</strong>.
      </span>
      <span className="text-black/70">Signed in as {admin}.</span>
      <form method="post" action="/impersonation/stop">
        <Button
          type="submit"
          size="sm"
          variant="outline"
          className="h-7 border-black/40 bg-transparent text-black hover:bg-black/10"
        >
          Stop
        </Button>
      </form>
    </div>
  );
}
